import { useEffect, useState } from "react";
import "./Header.css";
import logoImg from "../assets/logo.png"; // <- Import your logo

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);


  // Select the buttons
const donateBtn = document.querySelector(".btn.btn-secondary");
const joinBtn = document.querySelector(".btn.btn-primary");

// Function to scroll to contact section
function scrollToContact() {
  const contactSection = document.getElementById("contact");
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: "smooth" });
  }
}

// Attach click events
if (donateBtn) donateBtn.addEventListener("click", scrollToContact);
if (joinBtn) joinBtn.addEventListener("click", scrollToContact);

  // Scroll detection for "scrolled" class and show/hide
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrolled(currentScrollY > 50);

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setVisible(false); // scrolling down → hide
      } else {
        setVisible(true); // scrolling up → show
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <>
      <header
        className={`header ${scrolled ? "scrolled" : ""} ${visible ? "visible" : "hidden"}`}
      >
        <div className="header-container">
          <div className="logo">
            <img src={logoImg} alt="Mapesa Foundation" className="logo-image" />
          </div>

          <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
            <ul className="nav-list">
              <li><a href="#home" onClick={() => setMenuOpen(false)}>Home</a></li>
              <li><a href="#about" onClick={() => setMenuOpen(false)}>About</a></li>
              <li><a href="#programs" onClick={() => setMenuOpen(false)}>Projects</a></li>
              <li><a href="#impact" onClick={() => setMenuOpen(false)}>Impact</a></li>
              <li><a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a></li>
            </ul>
          </nav>

          <div className="header-actions">
                      <div className="header-actions">
            <button className="btn btn-secondary hidden"> Donate</button>
            <button className="btn btn-primary hidden">Join Us</button>
          </div>

          </div>

          <button
            className={`menu-toggle ${menuOpen ? "active" : ""}`}
            aria-label="Toggle menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <div
          className={`overlay ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(false)}
        ></div>
      </header>
    </>
  );
}
